import { Button } from '../ui/Button';
import { Panel } from '../ui/Panel';

/**
 * Shown when the legal page's code chunk fails to download, most often a visitor
 * holding an index.html from before a redeploy. Reloading fetches the new one.
 */
export default function LegalPageUnavailable() {
    return (
        <div className="relative mx-auto flex w-full max-w-3xl flex-col px-4 py-8 sm:px-6">
            <Panel variant="glass" padding="lg" className="flex flex-col items-start gap-3">
                <p className="text-body text-content-primary">This page could not be loaded.</p>
                <Button variant="primary" size="md" onClick={() => window.location.reload()}>
                    Reload
                </Button>
            </Panel>
        </div>
    );
}
